import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { PublicLayout } from '../../app/layouts/PublicLayout';
import { CopytradeView } from '../../components/copytrade/CopytradeView';
import { fetchPublishedCopytrade } from '../../features/copytrade/api/copytrade';
import type { CopytradeContent } from '../../types';

export default function CopytradePage() {
  const [content, setContent] = useState<CopytradeContent | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPublishedCopytrade().then(setContent).finally(() => setLoading(false));
  }, []);

  return (
    <PublicLayout>
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-cyan-400 animate-spin" strokeWidth={1.5} /></div>
      ) : (
        <CopytradeView content={content} />
      )}
    </PublicLayout>
  );
}
